import { Box, Chip, Grid, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import data from '../../data/company.json';
import PlatformData from '../../data/platforms/platform-list.json';

const footerLocales = "footer";

const FooterLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const quickLinks = [
        {
            title: `${footerLocales}.linksTitle1`,
            list: [
                { label: t("navigation.home"), to: "/" },
                { label: t("navigation.about"), to: "/about" },
                { label: t("navigation.blog"), to: "/blog" },
                { label: t("navigation.contact"), to: "/contact" }
            ]
        }
    ]

    return (
        <>
            <Box
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    pb: {xs: 3, md: 5},
                    position: 'relative'
                }}
                className="sectionDoubleSpacing"
            >
                <Grid
                    direction='row'
                    alignItems='start'
                    className="bodySideMargin1 sectionRadius sectionInSidePadding"
                    sx={{
                        backgroundColor: theme.palette.background.default
                    }}
                    container
                    spacing={{xs: 4, md: 10}}
                >
                    {/* Logo and Description */}
                    <Grid
                        size={{xs: 12, lg: 3}}
                        direction='column'
                        alignItems={{xs: 'center', md: 'start'}}
                    >
                        <Box
                            sx={{
                                width: 50,
                                pb: {xs: 1, md: 2},
                                margin: {xs: 'auto', md: '0%'}
                            }}
                        >
                            <img 
                                src="/images/logo/icon.png" 
                                alt="" 
                                width='100%'
                                style={{
                                    animation: 'bounceAnimation 0.5s infinite'
                                }}
                            />
                        </Box>

                        <Typography
                            fontSize={12}
                            textAlign={{xs: 'center', md: 'left'}}
                            lineHeight={1.75}
                        >
                            {t(`${footerLocales}.description`)}
                        </Typography>
                    </Grid>

                    {/* Links */}
                    <Grid
                        size={{xs: 6, lg: 3}}
                        direction='column'
                        alignItems='start'
                    >
                        {/* Company */}
                        {
                            quickLinks.map((linkGroup, index) => {
                                return <Stack
                                    key={index}
                                    direction='column'
                                    justifyContent='start'
                                    pb={2}
                                >
                                    <Typography
                                        fontSize={{xs: 14, lg: 16}}
                                        fontWeight={700}
                                        textAlign='left'
                                        lineHeight={1.5}
                                        pb={1.5}
                                    >
                                        {t(linkGroup.title)}
                                    </Typography>

                                    {
                                        linkGroup.list.map((link, linkIndex) => {
                                            return <Link
                                                key={linkIndex}
                                                to={link.to}
                                                style={{
                                                    textDecoration: 'none'
                                                }}
                                            >
                                                <Typography
                                                    fontSize={{xs: 12, lg: 14}}
                                                    fontWeight={400}
                                                    textAlign='left'
                                                    lineHeight={1.5}
                                                    color={theme.palette.text.primary}
                                                    pb={linkIndex === linkGroup.list.length - 1 ? 0 : 1}
                                                    sx={{
                                                        '&: hover': {
                                                            transform: 'scale(0.95)'
                                                        }
                                                    }}
                                                >
                                                    {link.label}
                                                </Typography>
                                            </Link>
                                        })
                                    }
                                </Stack>
                            })
                        }

                        {/* Platforms */}
                        <Stack
                            direction='column'
                            justifyContent='start'
                            pb={2}
                        >
                            <Typography
                                fontSize={{xs: 14, lg: 16}}
                                fontWeight={700}
                                textAlign='left'
                                lineHeight={1.5}
                                pb={1.5}
                            >
                                {t(`${footerLocales}.linksTitle2`)}
                            </Typography>

                            {
                                PlatformData?.en?.map((link, linkIndex) => {
                                    return <Link
                                        key={linkIndex}
                                        to={`/platform/${link.file}`}
                                        style={{
                                            textDecoration: 'none'
                                        }}
                                    >
                                        <Typography
                                            fontSize={{xs: 12, lg: 14}}
                                            fontWeight={400}
                                            textAlign='left'
                                            lineHeight={1.5}
                                            color={theme.palette.text.primary}
                                            pb={linkIndex === PlatformData?.en?.length - 1 ? 0 : 1}
                                            sx={{
                                                '&: hover': {
                                                    transform: 'scale(0.95)'
                                                }
                                            }}
                                        >
                                            {link.name}
                                        </Typography>
                                    </Link>
                                })
                            }
                        </Stack>
                    </Grid>

                    {/* Location */}
                    <Grid
                        size={{xs: 6, lg: 3}}
                        direction='column'
                        alignItems='start'
                    >
                        {/* <Box
                            sx={{
                                width: 50,
                                pb: {xs: 1, md: 2}
                            }}
                        >
                            <img 
                                src="/images/countries/SL Flag.png" 
                                alt="" 
                                width='100%'
                            />
                        </Box> */}

                        <Stack
                            direction='column'
                            justifyContent='start'
                            spacing={0.5}
                        >
                            <Typography
                                fontSize={{xs: 14, lg: 16}}
                                fontWeight={700}
                                textAlign='left'
                                lineHeight={1.5}
                                pb={1}
                            >
                                {t(`${footerLocales}.address1.company`)}
                            </Typography>

                            {
                                ['no', 'road', 'city', 'country'].map((item, index) => {
                                    return <Typography
                                        key={index}
                                        fontSize={{xs: 12, md: 14}}
                                        fontWeight={400}
                                        textAlign='left'
                                        lineHeight={1.5}
                                        color={theme.palette.text.primary}
                                    >
                                        {`${t(`${footerLocales}.address1.${item}`)}${index < 3 ? ',': ''}`}
                                    </Typography>
                                })
                            }

                            <Link
                                to={data.locationSL}
                                target="_blank"
                            >
                                <Chip 
                                    label={t(`${footerLocales}.map`)}
                                    color="primary" 
                                    variant="outlined"
                                    sx={{
                                        mt: 1,
                                        '&: hover': {
                                            transform: 'scale(0.95)'
                                        }
                                    }}
                                    icon={<LocationOnIcon />}
                                />
                            </Link>
                        </Stack>
                    </Grid>

                    {/* Contact */}
                    <Grid
                        size={{xs: 12, lg: 3}}
                    >
                        <Stack
                            direction='column'
                            justifyContent='start'
                            pb={2}
                        >
                            <Typography
                                fontSize={{xs: 14, lg: 16}}
                                fontWeight={700}
                                textAlign='left'
                                lineHeight={1.5}
                                pb={1.5}
                            >
                                {t(`${footerLocales}.socialMedia`)}
                            </Typography>

                            <Grid
                                direction='row'
                                justifyContent='start'
                                xs={12}
                                container
                                pt={1}
                            >
                                {
                                    data.socialMedia.map((item, index) => {
                                        return <Grid
                                            key={index}
                                            size={{xs: 2, md: 1, lg: 2}}
                                            pr={2}
                                            pb={2}
                                        >
                                            <Link
                                                to={item.link}
                                                target="_blank"
                                            >
                                                <Box
                                                    sx={{
                                                        width: 30,
                                                        '&: hover': {
                                                            transform: 'scale(0.9)'
                                                        }
                                                    }}
                                                >
                                                    <img 
                                                        src={item.img}
                                                        alt={item.label}
                                                        width='100%'
                                                    />
                                                </Box>
                                            </Link>
                                        </Grid>
                                    })
                                }
                            </Grid>
                        </Stack>
                    </Grid>

                    {/* Policies */}
                    <Grid
                        size={12}
                        display='flex'
                        direction={{xs: 'column-reverse', md: 'row'}}
                        justifyContent={{xs: 'start', md: 'space-between'}}
                        alignItems={{xs: 'center', md: 'center'}}
                        container
                    >
                        <Typography
                            fontSize={{xs: 10, md: 12}}
                            textAlign={{xs: 'center', md: 'left'}}
                            lineHeight={1.75}
                        >
                            {`© ${new Date().getFullYear()} ${t('company')} . All Rights Reserved`}
                        </Typography>

                        <Stack
                            direction='row'
                            spacing={{xs: 4, md: 2}}
                        >
                            {/* Privacy policy */}
                            <Link
                                to='/privacy-policy'
                                style={{
                                    textDecoration: 'none'
                                }}
                            >
                                <Typography
                                    fontSize={{xs: 12, md: 14}}
                                    textAlign='right'
                                    lineHeight={1.5}
                                    color={theme.palette.text.primary}
                                    sx={{
                                        '&: hover': {
                                            transform: 'scale(0.9)'
                                        }
                                    }}
                                >
                                    {t(`policies.privacy`)}
                                </Typography>
                            </Link>

                            {/* Terms and Conditions */}
                            <Link
                                to='/terms-and-conditions'
                                style={{
                                    textDecoration: 'none'
                                }}
                            >
                                <Typography
                                    fontSize={{xs: 12, md: 14}}
                                    textAlign='right'
                                    lineHeight={1.5}
                                    color={theme.palette.text.primary}
                                    sx={{
                                        '&: hover': {
                                            transform: 'scale(0.9)'
                                        }
                                    }}
                                >
                                    {t(`policies.terms`)}
                                </Typography>
                            </Link>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default FooterLayout;